/**
 * Global Labels Configuration (similar to Android strings.xml)
 * 
 * Usage:
 * - In TypeScript: Labels.get('common.save') or Labels.common.save
 * - In Template: {{ 'common.save' | label }}
 * 
 * Organization:
 * - Labels are organized by feature/module
 * - Use dot notation for nested access
 * - Use {0}, {1}, etc. for parameter interpolation
 */

export const APP_LABELS = {
  // ============================================
  // APP INFO
  // ============================================
  app: {
    name: 'Premium Report Form',
    nameWithYear: '{0} Premium Report Form',
  },

  // ============================================
  // COMMON LABELS
  // ============================================
  common: {
    save: 'Save',
    cancel: 'Cancel',
  },

  // ============================================
  // PREMIUM LABELS
  // ============================================
  premium: {
    direct: 'Admitted Premium',
    directPlural: 'Admitted Premiums',
    supplemental: 'Non-Admitted Premium',
    supplementalPlural: 'Non-Admitted Premiums',
    userDefinedDirect: 'User Defined Admitted Premium',
    userDefinedSupplemental: 'User Defined Non-Admitted Premium',
    supplementalVolume: 'Non-Admitted Premium Volume',
    foreignVolume: 'Foreign Premium Volume',
    udDirect: 'UD Admitted',
    udSupplemental: 'UD Non-Admitted',

  },

  // Example with single parameter: Labels.get('example.welcome', 'John')
  // Example with multiple parameters: Labels.get('example.range', 1, 100)
  example: {
    welcome: 'Welcome, {0}!',
    range: 'Value must be between {0} and {1}',
  },
} as const;

// Type definitions for strong typing
export type LabelKeys = NestedKeyOf<typeof APP_LABELS>;

// Helper type to get nested keys with dot notation
type NestedKeyOf<T, K = keyof T> = K extends keyof T & string
  ? T[K] extends Record<string, unknown>
    ? `${K}` | `${K}.${NestedKeyOf<T[K]>}`
    : `${K}`
  : never;
